import { logger } from './logger';
import { themeStore } from '~/lib/stores/theme';

export function waitForChameleon(): Promise<void> {
  return new Promise((resolve) => {
    const checkElement = () => {
      const element = document.getElementById('chmln');

      if (element && window.chmln) {
        logger.debug('Chameleon detected as loaded');
        resolve();
      } else {
        // retry after a short delay
        setTimeout(checkElement, 100);
      }
    };

    checkElement();
  });
}

export function isChameleonLoaded(): boolean {
  const element = document.getElementById('chmln');
  return !!(element && window.chmln);
}

export function showChameleonHelpbar(): void {
  if (window.chmln) {
    window.chmln.show('helpbar');
    logger.debug('Chameleon helpbar shown');
  }
}

export function applyThemeToChameleon(theme: string) {
  const chameleonElement = document.getElementById('chmln');

  if (chameleonElement) {
    chameleonElement.setAttribute('data-theme', theme);
    logger.debug(`Applied theme "${theme}" to Chameleon element`);
  } else {
    logger.debug('Chameleon element not found, will retry when available');
  }
}

async function waitForChameleonElement(theme: string): Promise<void> {
  await waitForChameleon();
  applyThemeToChameleon(theme);
}

export function handleThemeChange(theme: string) {
  // try to apply immediately
  const chameleonElement = document.getElementById('chmln');

  if (chameleonElement) {
    applyThemeToChameleon(theme);
  } else {
    // wait for element to exist
    waitForChameleonElement(theme);
  }
}

export function initChameleonThemeSubscription() {
  if (import.meta.env.VITE_DISABLE_CHAMELEON) {
    return;
  }

  // subscribe to theme changes
  themeStore.subscribe(handleThemeChange);

  // apply initial theme
  const initialTheme = themeStore.get();
  handleThemeChange(initialTheme);

  logger.debug('Chameleon theme subscription initialized');
}
